
import { GetterTree } from "vuex";
import { IPropertyEditState } from "../property-states.store";
import { IPropertyVideoModel } from "../../../../models/property";
import { itemStateConstant } from "../../../../common";

const videoGetters: GetterTree<IPropertyEditState, {}> = <GetterTree<IPropertyEditState, {}>>{
	service: (state: IPropertyEditState) => {
		return state.service;
	},
	listOfPropertyVideos: (state: IPropertyEditState): IPropertyVideoModel[] => {
        const videos = state.property.Videos || [];
        const result =  videos.filter(video => video.ItemState !== itemStateConstant.Deleted);
		return result;
	}
};

export default videoGetters;
